export default __webpack_public_path__ + "locales/de/ChangePhoneDialog.json?hash=31eb1aa28d8693e1e462e2d0b6675e9d";